// hcp Corporate Page - Unique Scoped JavaScript
// Initialize Slick Slider for Hero Section
$(document).ready(function() {
    // Only initialize if we're on the hcp corporate page
    if (!$('.hcp-corporate-page').length) return;
    
    $('.hcp-hero-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });
});

// hcp Corporate Page specific functionality
document.addEventListener('DOMContentLoaded', function() {
    // Only run if we're on the hcp corporate page
    if (!document.querySelector('.hcp-corporate-page')) return;
    
    // Smooth scrolling for anchor links within hcp page
    document.querySelectorAll('.hcp-corporate-page a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // hcp Corporate Form submission handling
    const hcpCorporateForm = document.querySelector('.hcp-corporate-form');
    if (hcpCorporateForm) {
        hcpCorporateForm.addEventListener('submit', function(e) {
            e.preventDefault();
            // Add form submission logic here
            alert('Thank you for your inquiry! We will get back to you soon.');
        });
    }

    // hcp FAQ Section Functionality
    const hcpFaqItems = document.querySelectorAll('.hcp-faq-item');
    
    hcpFaqItems.forEach(item => {
        const question = item.querySelector('.hcp-faq-question');
        
        if (question) {
            question.addEventListener('click', function() {
                const isActive = item.classList.contains('active');
                
                // Close all other FAQ items
                hcpFaqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
                
                // Toggle current item
                if (isActive) {
                    item.classList.remove('active');
                } else {
                    item.classList.add('active');
                }
            });
        }
    });

    // hcp Button click handlers
    const hcpEnquireButtons = document.querySelectorAll('.hcp-btn-enquire');
    hcpEnquireButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            // Scroll to contact form
            const contactForm = document.querySelector('.hcp-contact-form');
            if (contactForm) {
                contactForm.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // hcp Primary button click handler
    const hcpPrimaryButtons = document.querySelectorAll('.hcp-btn-primary');
    hcpPrimaryButtons.forEach(button => {
        if (!button.closest('.hcp-corporate-form')) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                // Scroll to contact form
                const contactForm = document.querySelector('.hcp-contact-form');
                if (contactForm) {
                    contactForm.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        }
    });

    // hcp Mobile touch scroll optimization
    const hcpScrollableElements = document.querySelectorAll('.hcp-gifts-grid, .hcp-steps-grid');
    hcpScrollableElements.forEach(element => {
        let isDown = false;
        let startX;
        let scrollLeft;

        element.addEventListener('mousedown', (e) => {
            isDown = true;
            element.classList.add('active');
            startX = e.pageX - element.offsetLeft;
            scrollLeft = element.scrollLeft;
        });

        element.addEventListener('mouseleave', () => {
            isDown = false;
            element.classList.remove('active');
        });

        element.addEventListener('mouseup', () => {
            isDown = false;
            element.classList.remove('active');
        });

        element.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - element.offsetLeft;
            const walk = (x - startX) * 2;
            element.scrollLeft = scrollLeft - walk;
        });
    });

    // hcp Intersection Observer for animations
    const hcpObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.animationPlayState = 'running';
            }
        });
    }, {
        threshold: 0.1
    });

    // Observe hcp animated elements
    document.querySelectorAll('.hcp-gift-item, .hcp-step-item, .hcp-service-item').forEach(el => {
        hcpObserver.observe(el);
    });
});

// hcp Utility functions
const hcpUtils = {
    // Debounce function for performance
    debounce: function(func, wait, immediate) {
        let timeout;
        return function executedFunction() {
            const context = this;
            const args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    // Check if element is in viewport
    isInViewport: function(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },

    // Smooth scroll to element
    scrollToElement: function(element, offset = 0) {
        if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
};

// hcp Window resize handler
window.addEventListener('resize', hcpUtils.debounce(function() {
    // Only run if we're on the hcp corporate page
    if (!document.querySelector('.hcp-corporate-page')) return;
    
    // Handle responsive adjustments if needed
    const hcpStepsGrid = document.querySelector('.hcp-steps-grid');
    const hcpGiftsGrid = document.querySelector('.hcp-gifts-grid');
    
    if (window.innerWidth <= 768) {
        // Mobile specific adjustments
        if (hcpStepsGrid) {
            hcpStepsGrid.style.scrollBehavior = 'smooth';
        }
        if (hcpGiftsGrid) {
            hcpGiftsGrid.style.scrollBehavior = 'smooth';
        }
    }
}, 250));

// hcp Page load optimization
window.addEventListener('load', function() {
    // Only run if we're on the hcp corporate page
    if (!document.querySelector('.hcp-corporate-page')) return;
    
    // Lazy load images if needed
    const hcpImages = document.querySelectorAll('.hcp-gift-item img, .hcp-service-item img');
    hcpImages.forEach(img => {
        if (img.loading !== 'lazy') {
            img.loading = 'lazy';
        }
    });
});
